export enum WDTCValues {
    linedString = "Lined Waterway",
    grassedString = "Grassed Waterway",
    trapezoid = "TRAPEZOIDAL",
    parabolic = "PARABOLIC",
}
